<template>
  <section class="book-container">
    <div class="content-max-width">

      <div class="featured flex" v-if="featured.length < 4">

        <article class="tile-link-module small"
          v-for="(service,index) of featured" :key="index"
        >
          <a :href="service.url">
            <img :src="service.image" :alt="service.title">

            <div class="content2">
              <h3>{{ service.title }}</h3>

              <button class="button-link-icon">
                <span class="button-text">{{ service.button_text }}</span>
                <span class="icon icon-right-arrow-no-bg"></span>
              </button>
            </div>
          </a>
        </article>

      </div>

      <div class="featured slider" v-else >

        <slick ref="slick" class="featured-slideshow"
          :options="{
            arrows:true, autoplay:true, autoplaySpeed:5000, slidesToScroll:1, slidesToShow:4,
            responsive: [
              { breakpoint: 1024, settings: { slidesToShow:4 } },
              { breakpoint: 900, settings: { slidesToShow:3 } },
              { breakpoint: 680, settings: { slidesToShow:2 } },
              { breakpoint: 500, settings: { slidesToShow:1 } }
            ]
          }"
        >
          <div class="wrap" v-for="(service,index) of featured" :key="index">
            <article class="tile-link-module small">
              <a :href="service.url">
                <img :src="service.image" :alt="service.title">

                <div class="content2">
                  <h3>{{ service.title }}</h3>

                  <button class="button-link-icon">
                    <span class="button-text">{{ service.button_text }}</span>
                    <span class="icon icon-right-arrow-no-bg"></span>
                  </button>
                </div>
              </a>
            </article>
          </div>
        </slick>

      </div>

    </div>

    <div class="grey-bg">
      <div class="content-max-width">

        <div class="form-search flex">

          <div class="form-field text search">
            <label>{{ search_heading }}</label>
            <input type="text"
              placeholder="Start typing..."
              v-model="payload.search"
            >
          </div>

          <div class="form-field select">
            <label>Filter by location</label>
            <select v-model="payload.location">
              <option :value="0">All Locations</option>

              <option
                v-for="location of locations"
                :value="location.id" :key="location.id"
              >
                {{ location.title }}
              </option>
            </select>
          </div>

          <button
            class="button grey-border"
            @click="payload.search = ''; payload.location = 0;"
          >
            <span class="icon-clear"></span> Clear filter
          </button>

        </div>

        <div class="all-results">

          <div class="results flex">
            <a  v-for="(link,index) of results" :href="link.url" :key="index">
              {{ link.title }}
            </a>
          </div>

        </div>

      </div>
    </div>

  </section>
</template>

<script>
import Slick from 'vue-slick'

export default {
  props: {
    featured: Array,
    services: Array,
    locations: Array,
    search_heading: String
  },
  components: { Slick },
  data () {
    return {
      payload: {
        search: '',
        location: 0
      },
    //   featured: []
    };
  },
  computed: {
    results () {
      if (this.payload.location === 0) {
        return this.services.filter((obj) => {
          // keyword-search
          return obj.title.toLowerCase().includes(this.payload.search.toLowerCase());
        })
      } else {
        return this.services.filter((obj) => {
          // match location, then keyword-search
          if (obj.locations.includes(this.payload.location)) {
            return obj.title.toLowerCase().includes(this.payload.search.toLowerCase());
          }
        })
      }
    }
  },
  mounted () {
    // this.featured = this.services.filter(obj => obj.featured === true)

    setTimeout(() => {
      // let location = new URLSearchParams(window.location.search).get('location')
      let location = this.$attrs.selected_location
      if (location) {
        console.log(location)
        this.payload.location = location
      }
    }, 100)
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/book-now/Index.vue